import useGetEditorNewspaper from './useGetEditorNewspaper'

export default useGetEditorNewspaper
